import Queries from '../queries';

const { GET_NOTIFICATION } = Queries;

export const typeDefs = `
    type Notification {
        id: String!
        isDismissed: Boolean!
    }
`;

const Query = {
    notification(_root, { id }) {

        if(!__CLIENT__ || !id) {

            return null;

        }

        try {

            const { data } = JSON.parse(localStorage.getItem(id) || '{}');

            return {
                id,
                isDismissed: data?.notification?.isDismissed === true,
                __typename: 'Notification',
            };

        } catch(err) {

            console.error(err);
            return null;

        }

    },
};

const Mutation = {
    dismissNotification: (_root, { id }, { cache }) => {

        const previous = cache.readQuery({
            query: GET_NOTIFICATION,
            variables: {
                id,
            },
        });

        const next = {
            notification: {
                ...previous.notification,
                isDismissed: true,
            },
        };

        cache.writeQuery({
            query: GET_NOTIFICATION,
            variables: {
                id,
            },
            data: next,
        });

        return next;

    },
};

export const resolvers = {
    Query,
    Mutation,
};
